export default "__VITE_ASSET__C786z8q0__"